import React, { Component, Fragment } from 'react'

import Login from '../../login/containerLogin';
import Loading from '../../common/loading';
import Statistics from '../statistics';
import imgEmpty from '../../images/online-security.gif';
import './style.scss';

export default class Dashboard extends Component {
    render() {
        const { user, role } = this.props;

        return (
            <Fragment>
                {
                    // solo login/refresh e ruoli bloccano la pagina: i caricamenti delle statistiche sono gestiti nei singoli grafici
                    (user.isLoading || role.isLoading) ?
                        <Loading /> :
                        (user.isAuthenticated && user.user.email !== undefined) ?
                            role.statistics ?
                                <Statistics role={role} /> :
                                <div className="text-center">
                                    <div className="emptyStatistics">
                                        <img alt="empty" src={imgEmpty} />
                                        <h3>
                                            Scegli un opzione dalla Dashboard
                                        </h3>
                                    </div>
                                </div>
                            :
                            <Login />
                }
            </Fragment>
        )
    }
}
